import styled from 'styled-components';
import ColorSF2 from './ColorSF2';

const ErrorMsgArea = styled.div`
  margin: 20px 10px 1px 10px;
  text-align: left;
  font: normal normal normal 14px/19px Open Sans;
  letter-spacing: 0px;
  color: ${ColorSF2.alertRed};
  opacity: 1;
`;

export default ErrorMsgArea;
